import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const insuredAgreement: AnswerPathTreeNode = { path: 'insuredAgreement ', nodeId: NodeIds.insuredAgreement };
